export default "__VITE_ASSET__DLnYC1kP__"